<template >
  <textarea
    v-model="displayjson"
    @input="handleInput"
    :rows="countRows"
    :class="'text-secondary form-control' + (this.inputObj.invalid? ' is-invalid': '')"
  >
  </textarea>

  <div
      v-if="jsonError"
      class="text-danger"
  >
    {{jsonError}}
  </div>
  <div
   v-if="inputObj.templates"
   class="mt-1"
  >
    <div class="btn btn-sm">
     {{$t('json_input.templates.title')}}:
    </div>

    <div
      v-for="(templateData, templateIndex) in inputObj.templates"
      @click.prevent="fillTemplate(templateData.value)"
      class="btn btn-sm btn-outline-secondary me-1 mb-1"
    >
      {{templateData.title}}
    </div>
  </div>
<!--
   <display-debug>
    <template #debugView>inputObj {{inputObj}}</template>
  </display-debug>
 -->
</template>

<script>

export default {
  name: "JsonInput2",
  components: {
  },
  props: {
    "inputObj": Object,
    "formObj": Object,
    "modelValue": {
      type: [Object],
      required: false,
      default: null,
    },
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      inputModel: null,
      timer: null,
      timer_delay: 500,
      is_locked: true,
      displayjson: null,
      jsonError: null,
      debounceTimer: null
    }
  },
  mounted() {
    if(
        !this.inputObj.val
        || this.inputObj.val == ''
    ) {
      this.displayjson = JSON.stringify( {}, null, 4);
    } else {
      this.displayjson = JSON.stringify(this.inputObj.val, null, 4);
    }
  },
  computed: {
    countRows() {
      let rows = 1;

      if(this.displayjson) {
        rows  = this.displayjson.split('\n').length
        rows = rows + 2;
      }
      if(rows < 5) {
        rows = 5;
      }
      return rows;
    }
  },
  methods: {
    fillTemplate(data) {
      let c = null;
      try {
        c = JSON.parse(this.displayjson);
      } catch (e) {
        c = {};
      }

      if (Object.keys(c).length > 0) {
        if (confirm(this.$t('json_input.input_confirm')) === true){
          this.displayjson = JSON.stringify(data, null, 4);
        }
      }else{
        this.displayjson = JSON.stringify(data, null, 4);
      }
      this.$emit('update:modelValue', data )
    },

    handleInput() {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        try {
          let c = JSON.parse(this.displayjson);
          this.$emit('update:modelValue', c )
          this.jsonError = null;
          this.displayjson = JSON.stringify(c, null, 4)
        } catch (e) {
          this.jsonError = e.message;
        }
      }, 750)
    }
  },
  watch: {
    inputObj: {
      handler() {
        this.inputModel = this.inputObj.val;
      },
      deep: true,
      immediate: true
    }
  },
};
</script>